<div>

    <app-message-box [content]="errors"></app-message-box>

    <app-wait *ngIf="loading"></app-wait>

</div>
